/**
 * @name PortugueseTranslations
 * @description Traducciones en portugués
 */

export const PortugueseTranslations = {
  // *************************************
  // GenericMessages                    
  // *************************************
  GenericMessages: {
    es: 'Español',
    en: 'English',
    pt: 'Português',
    app: 'Aplicativo',
    apps: 'Aplicativos',
    sidebar: 'Menu lateral',
    loading: 'Carregando',
    company: 'Empresa',
    rows: 'Linhas',
    columns: 'Colunas',
    photo: 'Foto',
    name: 'Nome',
    names: 'Nomes',
    lastName: 'Sobrenome',
    lastNames: 'Sobrenomes',
    job: 'Post',
    jobs: 'Baias',
    area: 'Area',
    areas: 'Áreas',
    branch: 'Filial',
    branches: 'Filiais',
    supervisor: 'Supervisor',
    supervisors: 'Supervisores',
    level: 'Nível',
    levels: 'Níveis',
    levelDescription: 'Descrição do nível',
    competence: 'Competência',
    compentencies: 'Competências',
    gender: 'Gênero',
    age: 'Idade',
    male: 'Masculino',
    female: 'Fêmea',
    scale: 'Escala',
    day: 'Dia',
    days: 'Dias',
    week: 'Semana',
    weeks: 'Semanas',
    month: 'Mês',
    months: 'Meses',
    year: 'Ano',
    years: 'Anos',
    daily: 'Diário',
    weekly: 'Semanal',
    biweekly: 'Quinzenalmente',
    monthly: 'Mensal',
    bimonthly: 'Bimestralmente',
    quarterly: 'Trimestralmente',
    biyearly: 'Semestre',
    annually: 'Anual',
    date: 'Data',
    dates: 'Datas',
    birthDate: 'Data de nascimento',
    startDate: 'Data de início',
    endDate: 'Data de final',
    dueDate: 'Data de vencimento',
    commitmentDate: 'Data de compromiso',
    creationDate: 'Data de criação',
    expirationDate: 'Data de expiração',
    registrationDate: 'Data de registro',
    lastUpdateDate: 'Data da última atualização',
    lastUpdate: 'Última atualização',
    startTime: 'Hora de início',
    endTime: 'Hora de término',
    start: 'Início',
    end: 'Término',
    read: 'Ler',
    unread: 'Unread',
    clear: 'Claro',
    open: 'Abrir',
    data: 'Dados',
    step: 'Etapa',
    note: 'Observação',
    email: 'Email',
    academicLevel: 'Nível acadêmico',
    phone: 'Número de telefone',
    civilStatus: 'Estado civil',
    seniority: 'Antigo',
    employee: 'Funcionário',
    employees: 'Colaboradores',
    employeeCode: 'Código do colaborador',
    employeeStatus: 'Estado do colaborador',
    employeesOf: 'Colaboradores de',
    backup: 'Backup',
    backupOf: 'Backup de',
    option: 'Opção',
    options: 'Opções',
    seeOptions: 'Mais opções',
    conversations: 'Conversas',
    survey: 'Sonda',
    agenda: 'Agenda',
    catcher: 'Captura',
    admin: 'Administrador',
    adminOf: 'Gestão',
    of: 'de',
    to: 'para',
    or: 'ou',
    and: 'e',
    toDate: 'a',
    from: 'De',
    until: 'Até',
    user: 'Usuário',
    users: 'Usuários',
    userExternal: 'Usuário externo',
    team: 'Equipe',
    welcome: 'Bem-vindo!',
    welcomeTalentry: 'Bem-vindo ao Talentry',
    hello: 'Olá',
    niceToHaveYouBack: 'É bom ter você de volta no Talentry.',
    nextDelivery: 'Próxima entrega a vencer',
    nextDeliveryDate: 'Fecha de próxima entrega',
    earringsToRecognize: 'Pendientes por reconocer',
    pendingToRedeem: 'Pendientes por canjear',
    goTalentry: 'Vá para Talentry',
    error: 'Erro',
    errros: 'Erros',
    noErrors: 'Nenhum erro encontrado',
    noResults: 'Nenhum resultado encontrado',
    noResultsFoundSelectedFilters: 'Nenhum resultado encontrado com os filtros selecionados',
    errorContactAdmin: 'Algo correu mal, contacte o administrador',
    userBlockedContactAdmin: 'Usuário bloqueado, entre em contato com o administrador.',
    languageUpdated: 'O idioma foi atualizado corretamente',
    responsibilities: 'Responsabilidades',
    respProgressTab: 'Avanço das responsabilidades',
    free: 'Grátis',
    everybody: 'Todo o mundo',
    nobody: 'Ninguém',
    none: 'Nenhum',
    nonee: 'Nenhum',
    all: 'Todos',
    seeAll: 'Ver todos',
    seeDetail: 'Ver detalhe',
    seeDetails: 'Veja detalhes',
    seeMore: 'Ver mais',
    copy: 'Copiar',
    search: 'Procurar',
    percentage: 'Percentagem',
    average: 'Média',
    current: 'Atual',
    reply: 'Resposta',
    progress: 'Encaminhar',
    example: 'Exemplo',
    examples: 'Exemplos',
    duration: 'Duração',
    archive: 'Arquivo',
    archived: 'Arquivado',
    onTime: 'Na hora',
    late: 'Atrasado',
    total: 'Total',
    min: 'Mínimo',
    max: 'Máximo',
    chars: 'Caracteres',
    weight: 'Peso',
    sum: 'Soma',
    status: 'Status',
    detail: 'Detalhe',
    details: 'Detalhes',
    concept: 'Conceito',
    description: 'Descrição',
    localization: 'Localização',
    location: 'Localização',
    address: 'Morada',
    city: 'Cidade',
    state: 'Estado',
    country: 'País',
    private: 'Particular',
    comment: 'Comente',
    comments: 'Comentários',
    seeComment: 'Veja o comentário',
    sendComment: 'Enviar comentário',
    confirmDeleteComment: 'Tem certeza de que deseja excluir seu comentário?',
    totalOfComments: 'Total de comentários',
    filter: 'Filtro',
    filters: 'Filtros',
    filtered: 'Filtrado',
    byFilters: 'Por filtros',
    show: 'Exposição',
    showing: 'Mostrando',
    register: 'Registro',
    registers: 'Registros',
    totalItems: 'Total de itens',
    add: 'Adicionar',
    edit: 'Editar',
    delete: 'Remover',
    deleted: 'Removido',
    select: 'Selecionar',
    selectAll: 'Seleccionar tudo',
    unselect: 'Desmarcar',
    unselectAll: 'Desmarcar tudo',
    unselectSelected: 'Desmarcar seleccionado',
    selected: 'Seleccionado',
    selecteds: 'Seleccionado',
    selectEmployees: 'Selecionar colaboradores',
    selectedEmployees: 'Funcionários selecionados',
    item: 'Elemento',
    items: 'Elementos',
    noMatches: 'Nenhuma correspondência encontrada',
    mandatory: 'Obrigatório',
    attachedImage: 'Imagem anexada',
    attachedFile: 'Anexo',
    restore: 'Restaurar',
    undo: 'Desfazer',
    export: 'Exportar',
    import: 'Importar',
    download: 'Baixar',
    unableToDownload: 'Não é possível fazer o download',
    successfulDownload: 'O download foi realizado com sucesso',
    unfindFiles: 'Nenhum arquivo encontrado para download',
    timeWarning: 'O download pode demorar alguns minutos',
    nextPage: 'Página seguinte',
    previousPage: 'Página anterior',
    sendToAuth: 'Enviar para autorização',
    back: 'Voltar',
    next: 'Próximo',
    exit: 'Partida',
    history: 'História',
    historical: 'Histórico',
  },
  FormatDates: {
    short: 'DD/MM/YYYY',
    long: 'LL',
    birthday: 'DD/MM',
    shortDate: '{{date, DD/MM/YYYYY}}',
    invalidDate: 'Por favor insira uma data válida',
    invalidMinDate: 'Por favor insira uma data válida. A data não deve ser anterior à data mínima',
    invalidMaxDate: 'Por favor insira uma data válida. A data não deve ser posterior à data máxima'
  },
  StatusText: {
    yes: 'Sim',
    not: 'Não',
    true: 'Alto',
    false: 'Descer',
    active: 'Ativo',
    inactive: 'Inativo',
    toBeApproved: 'Para aprovar',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
    notConcluded: 'Não terminou',
    concluded: 'Concluído',
    inRevision: 'Em revisão',
    awaiting: 'Em espera',
    pending: 'Pendente'
  },
  DialogConfirm: {
    approve: 'Aprovar',
    authorize: 'Autorizar',
    save: 'Salvar',
    send: 'Enviar',
    accept: 'Aceitar',
    confirm: 'Confirme',
    continue: 'Continuar',
    cancel: 'Cancelar',
    close: 'Fechar',
    reject: 'Recusar',
    remove: 'Eliminar',
    understood: 'Entendido',
    finish: 'Finalizar'
  },
  HttpResponse: {
    error: 'Erro!',
    success: 'Êxito!',
    unauthorized: 'Método não autorizado. Erro 405',
    somethingWentWrong: 'Algo inesperado aconteceu, tente novamente.',
    badRequest: 'Verifique todos os campos.'
  },
  FormsGeneralTexts: {
    required: 'Obrigatório',
    optional: 'Opcional',
    range: 'O intervalo permitido está entre',
    rangeLength: 'O limite de caracteres está entre',
    and: 'e',
    min2Chars: 'Deve conter mínimo de 2 caracteres',
    min3Chars: 'Deve conter mínimo de 3 caracteres',
    min4Chars: 'Deve conter mínimo de 4 caracteres',
    min8Chars: 'Deve conter mínimo de 8 caracteres',
    max20Chars: 'Deve conter máximo de 20 caracteres',
    max25Chars: 'Deve conter máximo de 25 caracteres',
    max100Chars: 'Deve conter máximo de 100 caracteres',
    max250Chars: 'Deve conter máximo de 250 caracteres',
    max500Chars: 'Deve conter máximo de 500 caracteres',
    oneSymbol: 'Deve conter pelo menos um símbolo',
    oneDigit: 'Deve conter pelo menos um número',
    oneCapitalLetter: 'Deve conter uma letra maiúscula',
    oneLowerLetter: 'Deve conter uma letra minúscula',
    onlyDigits: 'Deve conter 0-9 dígitos apenas',
    valueCannotBeEqual: 'O valor não pode ser igual a',
    notMultipleSpaces: 'Não deve conter vários espaços'
  },
  // *************************************
  // Time                            
  // *************************************
  Time: {
    hour: 'Hora',
    hours: 'Horas',
    minute: 'Minuto',
    minutes: 'Minutos',
    second: 'Segundo',
    seconds: 'Segundos'
  },
  // *************************************
  // WeekDays                            
  // *************************************
  WeekDays: {
    monday: 'Segunda-feira',
    tuesday: 'Terça-feira',
    wednesday: 'Quarta-feira',
    thursday: 'Quinta-feira',
    friday: 'Sexta-feira',
    saturday: 'Sábado',
    sunday: 'Domingo'
  },
  WeekDaysShort: {
    monday: 'Seg',
    tuesday: 'Ter',
    wednesday: 'Qua',
    thursday: 'Qui',
    friday: 'Sex',
    saturday: 'Sáb',
    sunday: 'Dom'
  },
  // *************************************
  // Months                            
  // *************************************
  Months: {
    jan: 'Janeiro',
    feb: 'Fevereiro',
    mar: 'Março',
    apr: 'Abril',
    may: 'Maio',
    jun: 'Junho',
    jul: 'Julho',
    aug: 'Agosto',
    sep: 'Setembro',
    oct: 'Outubro',
    nov: 'Novembro',
    dec: 'Dezembro',
  },
  MonthsShort: {
    jan: 'Jan',
    feb: 'Fev',
    mar: 'Mar',
    apr: 'Abr',
    may: 'Mai',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Ago',
    sep: 'Set',
    oct: 'Out',
    nov: 'Nov',
    dec: 'Dez'
  },
  // *************************************
  // Applications                     
  // *************************************
  Applications: {
    sysAdmin: 'sysAdmin',
    settings: 'Configurações',
    management: 'Gestão',
    acknowledgements: 'Reconhecimientos',
    indicators: 'Indicadores',
    indicatorsAccum: 'Indicadores Acumulados',
    evaluations: 'Avaliações',
    communication: 'Comunicação',
    academy: 'Academy',
    developmentPlan: 'Plano de desenvolvimento'
  },
  // *************************************
  // Reports                             
  // *************************************
  Report: {
    report: 'Relatório',
    reports: 'Relatórios',
    export: 'Exportar',
    columns: 'Colunas',
    exportToPNG: 'Exportar para PNG',
    exportToJPG: 'Exportar para JPG',
    exportToCsv: 'Exportar para CSV',
    exportToPdf: 'Exportar para PDF',
    exportToExcel: 'Exportar para Excel',
    exportAllToExcel: 'Exporte tudo para o Excel',
    exportFiltetredToExcel: 'Exportar filtragem para o Excel',
    selectAReport: 'Selecione um relatório',
    selectExportOptions: 'Selecione a opção que deseja exportar.',
    selectColumnsToShow: 'Selecione as colunas que deseja mostrar ou ocultar.'
  },
  // *************************************
  // Log In                             
  // *************************************
  Login: {
    sessionStart: 'Log',
    keepSess: 'Não faça logout',
    enterLogIn: 'Entrar',
    forgotPassword: 'Esqueceu sua senha?',
    userEnterpriseId: 'usuário.idempresa',
    password: 'Senha',
    sessionExpired: 'A sessão expirou',
    sessionExtended: 'A sessão foi estendida',
    sessionExpiringTitle: 'Sua sessão está prestes a expirar!',
    sessionExpiringBody: 'Você deseja continuar e estender sua sessão?',
    sessionOf: 'Sessão de',
    timeRemaining: 'Tempo restante',
    closeSession: 'Fechar sessão',
    continueSession: 'Continuar sessão',
    extendingSession: 'Estendendo sessão...'
  },
  // *************************************
  // Topbar                             
  // *************************************
  Topbar: {
    home: 'Casa',
    goBack: 'Volte',
    notification: 'Notificação',
    notifications: 'Notificações',
    notificationsCenter: 'Centro de notificação',
    noNotifications: 'Você ainda não tem notificações',
    errorNotifications: 'Notificações não carregadas',
    markAllRead: 'Marcar todos como lidos',
    noApps: 'Você ainda não tem aplicativos atribuídos',
    adminMenu: 'Menu do administrador',
    userMenu: 'Menu usuário',
    setting: 'Configurações',
    onboarding: 'Onboarding',
    logout: 'Logout',
    language: 'Linguagem'
  },
  // *************************************
  // ForgotPassword
  // *************************************
  ForgotPass: {
    retrievePassword: 'Recuperar senha',
    retrieveMSG: 'Se você esqueceu sua senha e não pode acessar sua conta Talentry, digite seu usuário, em breve você receberá uma mensagem para o seu e-mail registrado para que você possa alterar sua senha.',
    retrieve: 'Recuperar',
    procReq: 'Processando seu pedido...',
    invalidUser: 'Você precisa inserir um usuário válido.',
  },
  // *************************************
  // ChangePassword
  // *************************************
  ChangePass: {
    changePass: 'Alterar a sua palavra-passe',
    enterNewPass: 'Digite sua nova senha',
    configProcess: 'O processo de configuração é rápido e fácil, basta digitar sua senha para iniciar a aventura',
    passMustMeet: 'A senha deve estar em conformidade com os seguintes recursos:',
    mustHaveSymDot: 'Ele deve conter pelo menos um caractere diferente de letra ou dígito, o período de exemplo (.), vírgula (,), hífen (-) e assim por diante.',
    mustBetweenDigit0: 'Deve conter pelo menos um número entre 0 e 9.',
    mustHaveMin8Chars: 'Ele deve conter mínimo 8 caracteres.',
    atLeastCap: 'Ele deve conter pelo menos uma letra maiúscula e uma letra minúscula.',
    errorToChangePass: 'Para alterar sua senha você precisa solicitar uma alteração, então você receberá um e-mail que você precisa clicar em.',
    previousPass: 'Palavra-passe anterior',
    newPass: 'Nova senha',
    confirmPass: 'Confirme a senha',
    noPassMatch: 'As senhas não correspondem',
  },
  // *************************************
  // UnlockUser
  // *************************************
  UnlockUser: {
    unlockAccount: 'Desbloqueio de conta',
    userUnlocked: 'Usuário desbloqueado!',
    emailExpiredMSG: 'O email expirou. Para desbloquear sua conta, é necessário que você tente fazer login novamente. Depois, você receberá um novo email no qual é necessário clicar.'
  },
  // *************************************
  // Footer
  // *************************************
  Footer: {
    allRightsReserved: 'Todos os direitos reservados.',
    noticePrivacy: 'Aviso de privacidade',
    termsUse: 'Termos de uso'
  },
  // *************************************
  // Home                            
  // *************************************
  Home: {
    mission: 'Missão',
    vision: 'Visão',
    values: 'Valores',
    goals: 'Metas',
    purpose: 'Objetivo',
    principles: 'Princípios',
    attributes: 'Promessa de marca',
    man: 'Masculino',
    woman: 'Mulheres',
    genderDemographics: 'Demografia de gênero',
    anniversaries: 'Aniversários trabalhistas',
    anniversariesMonth: 'Aniversários trabalhistas em',
    noAnniversariesFound: 'Não há próximos aniversários de trabalho em',
    birthdays: 'Aniversário',
    birthdaysMonth: 'Aniversário em',
    noBirthdaysFound: 'Não há próximos aniversários em',
    today: 'Hoje',
    tomorrow: 'Manhã',
    youExternalUser: 'Você é um usuário externo'
  },
  // *************************************
  // News                            
  // *************************************
  News: {
    new: 'Aviso',
    news: 'Avisos',
    noNews: 'Sem anúncios',
    seeAllNews: 'Veja todos os avisos',
    importantAnnouncements: 'Comunicações e anúncios importantes.',
    all: 'Todos',
    forAll: 'É para todos',
    forSupervisor: 'É para supervisor',
    title: 'Título',
    subject: 'Importa',
    message: 'Mensagem',
    body: 'Corpo',
    noPastDates: 'As datas não devem ser anteriores a hoje e a data de vencimento deve ser igual ou posterior à data de início',
    pastDates2: 'A data de vencimento deve ser igual ou posterior à data de início',
    newsDeleteSuccess: 'Os avisos foram removidos com êxito',
    newsDeleteError: 'Ocorreu um erro ao processar a solicitação',
    addNews: 'Adicionar aviso',
    editNews: 'Editar aviso',
    create: 'Criar',
    sendNews: 'Enviar avisos',
    sendEmail: 'Enviar correio',
    sendNotification: 'Enviar notificação',
    emailSettings: 'Definições de correio',
    sendSettings: 'Configurações de remessa',
  },
  // *************************************
  // Settings
  // *************************************
  Settings: {
    profileConfig: 'Configurações de perfil',
    personalData: 'Dados pessoais',
  },
  // *************************************
  // Responsibilities
  // *************************************
  Responsibilities: {
    responsibility: 'Responsabilidade',
    respReport: 'Aqui você pode baixar as responsabilidades de sua estrutura.',
    noRespReport: 'Sua estrutura ainda não tem responsabilidades.',
    structureResponsibilities: 'Responsabilidades da estructura',
    configByEmployee: 'Definir responsabilidades pelo colaborador',
    seeingMy: 'Você está vendo suas responsabilidades',
    seeingOf: 'Você está vendo as responsabilidades de',
    selectEmployeeResponsibilities: 'Selecione um funcionário para visualizar suas responsabilidades',
    progressByEmployee: 'Avanços do colaborador',
    toBeApproved: 'Para aprovar',
    revertStatus: 'Status de retorno',
    revertStatusResp: 'Reverter status de responsabilidades',
    rejectResp: 'Rejeitar responsabilidades',
    whyRevertingStatus: 'Por que as responsabilidades estão retornando do status?',
    whyRejectingStatus: 'Por que as responsabilidades estão sendo rejeitadas?',
    minItemsIs: 'O mínimo de elementos é ',
    maxItemsIs: ', o máximo de elementos é ',
    weightTotal: 'e a soma do seu peso deve ser 100',
    minRespIs: 'O número mínimo de responsabilidades é ',
    maxRespIs: ', o número máximo de elementos é ',
    sumRespWeight: ' e a soma do seu peso deve ser 100',
    areaCode: 'Código de área'
  },
  // *************************************
  // UploadFile                    
  // *************************************
  UploadFile: {
    dragAndDrop: 'Arraste e solte seu arquivo ',
    browseFile: 'ou clique aqui para examinar seu dispositivo',
    attachFile: 'Anexar arquivo',
    attachedImage: 'Imagem anexada',
    attachedFile: 'Anexo',
    downloadFile: 'Baixar anexo',
    deleteFile: 'Excluir anexo',
    restoreFile: 'Restaurar arquivo',
    file: 'Arquivo',
    files: 'Arquivos',
    format: 'Formato',
    aspectRatio: 'Relação de aspecto',
    messageFileRejected: 'O arquivo {{fileName}} foi rejeitado. ',
    messageFileTooBig: 'O arquivo é muito grande. O limite de tamanho é {{maxSize}} MB. ',
    messageInvalidType: 'Tipo de arquivo não suportado. ',
    messageAddedFile: 'O arquivo {{fileName}} foi adicionado com sucesso. ',
    messageRemovedFile: 'O arquivo {{fileName}} foi deletado. '
  },
  // *************************************
  // Massive Uploads                    
  // *************************************
  MassiveUploads: {
    downloadBaseFile: 'Baixar arquivo base vazio',
    descriptionError: 'Descrição do erro',
    successUpload: 'Os registros de upload em massa foram inseridos com sucesso.',
    errorUpload: 'Há erros em alguns registros no upload em massa.',
    uploadZIPFileMessage: 'O nome de cada arquivo a ser carregado dentro do ZIP deve ser semelhante ao exemplo a seguir'
  },
  // *************************************
  // Shedule                            
  // *************************************
  Shedule: {
    checkIn: 'Verificar em tempo',
    departure: 'Hora de partida',
    entryHours: 'Horário de entrada',
    departureTime: 'Hora de partida',
    workdays: 'Dias úteis',
    lookingYouShedule: 'Você está olhando para sua programação',
    lookingAtShedule: 'Você está olhando a programação',
    scheduleSetting: 'Configuração de programação',
    scheduleReview: 'Revisão de cronograma',
    whyApproveSchedule: 'Por que você aprova a programação?',
    whyRejectingSchedule: 'Por que você está rejeitando a programação?',
    rejectSchedule: 'Rejeitar programação',
    approveSchedule: 'Aprovar programação',
  },
  // *************************************
  // Backup                            
  // *************************************
  BackupSettings: {
    assignBackup: 'Atribuição de backup',
    backupAssignments: 'Tarefas de backup',
    periodApply: 'Em que período será aplicado?',
    whoYourBackup: 'Quem será seu backup?',
    warningBackup: 'Nota: o backup é usado apenas para o módulo da Central de Ajuda',
    sureCancelBackup: 'Tem certeza de que deseja cancelar esta atribuição de backup?',
    sureRejectBackup: 'Tem certeza de que deseja rejeitar esta atribuição de backup?',
    commentCancelBackup: 'Escreva um comentário para o cancelamento deste backup:',
    commentRejectBackup: 'Escreva um comentário para o colaborador que selecionou você:',
    cancelBackup: 'Cancelar backup',
    rejectBackup: 'Rejeitar backup',
    infoAlreadyCancel: 'Não é possível cancelar esta atribuição de backup porque ela já foi cancelada.',
    infoNotPossibleCancel: 'Não é possível cancelar esta atribuição de backup.',
    infoNotPossibleCancelstartDate: 'Não é possível cancelar esta atribuição de backup porque a data de início já passou.',
    infoAlreadyReject: 'Não é possível rejeitar esta atribuição de backup porque ela já foi rejeitada.',
    infoNotPossibleReject: 'Não é possível rejeitar esta atribuição de backup.',
    infoNotPossibleRejectTomorrow: 'Não é possível rejeitar esta atribuição de backup porque a data de início é amanhã.',
    backupLog: 'Bitácora de Backup',
    catalogResp1: 'Aprobar / Autorizar planes de indicadores',
    catalogResp2: 'Registrar resultados de indicadores',
    catalogResp3: 'Aprobar / Autorizar indicadores acumulados',
    catalogResp4: 'Realizó una actualización',
    catalogResp5: 'Atender/Resolver solicitudes en Centro de ayuda',
    requestDescription: 'Descripción de la solicitud',
    aplicantBackup: 'Solicitante',
    respToDelegate: 'Qué responsabilidades delegarás',
    hasNotResp: 'no tiene responsabilidades que delegar',
    respIndicatorsBackup: 'Responsabilidades de Indicadores',
    respHelpDeskBackup: 'Responsabilidades de Centro de Ayuda',
    confirmed: 'Confirmado',
    rejected: 'Rejeitado',
    cancelled: 'Cancelado',
    finalized: 'Terminado',
    createdBackup: 'Creó una solicitud de backup',
    rejectedBackup: 'Rechazó la solicitud de backup',
    canceledBackup: 'Canceló la solicitu de backup',
    madeBackup: 'Realizó una actualización',
  },
  // *************************************
  // Request Job                            
  // *************************************
  Request: {
    actualJob: 'Trabalho atual',
    requiredJob: 'Trabalho requerido',
    jobChange: 'Mudança de emprego',
    lookingYouRequest: 'Você está vendo seus pedidos',
    lookingAtRequest: 'Você está visualizando solicitações de',
    requestReview: 'Revisão de mudança de emprego',
    whyApproveRequest: 'Por que você aprova o pedido?',
    whyRejectingRequest: 'Por que você está rejeitando o pedido?',
    rejectRequest: 'Rejeitar pedido',
    approveRequest: 'Aprovar pedido',
    selectnewJob: 'Selecione sua nova posição',
    warningRequest: 'Ao mudar a posição de um colaborador, se a nova posição tiver uma duração diferente do seu período atual, o período atual será truncado e serão gerados períodos mensais até o início do período correspondente ao cargo para o qual a mudança será feita.'
  },
  // *************************************
  // Notifications                     
  // *************************************
  Notifications: {
    // Gral. Talentry
    adminResponsibilitiesToActive: 'Seu administrador alterou o status de suas responsabilidades para ativo',
    adminResponsibilitiesApproved: 'Seu administrador aprovou suas responsabilidades',
    adminResponsibilitiesRejected: 'Seu administrador rejeitou suas responsabilidades',
    supervisorResponsibilitiesToActive: 'Seu supervisor alterou o status de suas responsabilidades para ativo',
    supervisorResponsibilitiesApproved: 'Seu supervisor aprovou suas responsabilidades',
    supervisorResponsibilitiesRejected: 'Seu supervisor rejeitou suas responsabilidades',
    responsibilitiesToApprove: 'Você tem responsabilidades pendentes para aprovar do <colaborador>',
    birthdayReminder: 'Informamos que em <dias> dia(s) será aniversário de <colaborador>',
    evaluationParticipant: 'Informamos que você foi escolhido para participar da avaliação <evaluacion>',
    shedulePendingToSend: 'Você tem o agendamento pendente para configurar e enviar para aprovação.',

    // Indicadores
    assignedResultsManager: 'Você foi designado como gerente de resultados para um <tipoMetrica> no catálogo',
    suggestedIndicators: '<colaborador> sugeriu um indicador do catálogo para você',
    periodPlanApproved: 'Seu plano do <periodo> foi aprovado por <colaborador>',
    periodPlanRejected: 'Seu plano do <periodo> foi rejeitado por <colaborador>',
    periodResultsAuthorized: 'Seus resultados do <periodo> foram autorizados por <colaborador>',
    periodResultsRejected: 'Seus resultados do <periodo> foram rejeitados por <colaborador>',
    periodPenalizedBySupervisor: 'Seu plano <periodo> foi penalizado em <porcentaje>% por <colaborador>',
    pendingPlansApprove: 'Você tem planos pendentes para aprovar',
    pendingResultsAuthorize: 'Você tem resultados pendentes para autorizar',
    assignedAsBackup: 'Você foi designado como backup do <colaborador> de <fechaInicio> para <fechaFin>',
    newBackupAssignments: 'Existem novas atribuições de backup',
    adminCancelled: 'O administrador cancelou sua atribuição de backup',
    backupRejected: '<colaborador> rejeitou sua atribuição de backup',
    newIndicatorsCatalogAdded: 'Indicadores foram adicionados ao catálogo',
    backupPeriodEnded: 'Seu período de backup terminou',
    reminderSendPlan: 'Você tem até <fecha> para enviar seu plano de indicador do <periodo>',
    reminderSendResults: 'Você tem até <fecha> para enviar seus resultados do <periodo>',
    reminderSendPlanPeriods: 'Você tem até <fecha> para enviar seu plano de indicadores do <periodo> - <periodoFin>',
    resultIndicatorCaptured: 'O resultado de um indicador do catálogo que você tem em seu plano <periodo> foi capturado',
    resultModificated: 'O resultado de um indicador de catálogo que você tem em seu plano <periodo> foi modificado',

    // Reconocimientos
    redeptionCancelled: 'Seu resgate para <premio> foi cancelado',
    deliveryCancelled: 'Sua entrega de <reconocimiento> para <colaborador> foi cancelada',
    pendingPrizeRedeptions: 'Você tem excelentes resgates de prêmios para se registrar',
    assignedKeeperPrizeBranch: 'Você foi designado como responsável pelo prêmio <premio> em <sucursal>',
    assignedKeeperPrize: 'Você foi designado como gerente de prêmios <premio>',
    assignedKeeperDeliveryPrizes: 'Você foi designado como gerente de entrega de prêmios',
    congratulationsAcknowledgements: 'Parabéns! <colaborador> forneceu um <reconocimiento>',
    acknowledgementsToAcknowledge: 'Você recebeu <reconocimiento> para reconhecer',
    timeToAcknowledge: 'É hora de reconhecer!',
    acknowledgementsToRedeem: 'Você foi atribuído <reconocimiento> para resgatar',
    respondAcknowledgements: '<colaborador> respondeu a você pelo reconhecimento que você fez',
    deliveryReceivedCancelled: 'Seu reconhecimento recebido de <colaborador> foi cancelado',

    // Evaluaciones
    chooseFriendsEvaluation: 'Agora você pode escolher seus amigos na avaliação <evento>',
    chosenAsFriendEvaluation: 'Você foi escolhido como amigo de <colaborador> na avaliação <evento>',
    checkResultsEvaluation: 'Revise os resultados da avaliação <evento>',
    timeToEvaluate: 'É hora de avaliar!',
    notFinishEvaluate: 'Você não terminou de avaliar!',
    makeActionPlan: 'Você ainda não tem nenhuma atividade ligada à avaliação <evaluacion>, nós convidamos você a trabalhar em seu plano de ação',

    // Indicadores Acumulados
    accumulatedIndicatorApproved: 'Seu indicador acumulado foi aprovado',
    accumulatedIndicatorRejected: 'Seu indicador acumulado foi rejeitado',
    advancesAccumulatedIndicatorApproved: 'Seus avanços em seu indicador acumulado foram autorizados',
    advancesAccumulatedIndicatorRejected: 'Seus avanços em seu indicador acumulado foram rejeitados',
    pendingAccumulatedIndicators: 'Você acumulou indicadores de seu equipamento aguardando revisão',
    pendingAdvancesAccumulatedIndicators: 'Você tem progresso nos indicadores acumulados de sua equipe, aguardando revisão',

    // Plan de Desarrollo
    activitiesToApprove: 'Você tem atividades pendentes para aprovar',
    activityApproved: 'Sua atividade de tipo <actividad> foi autorizada',
    activityRejected: 'Sua atividade de tipo <actividad> foi rejeitada',
    suggestionsActivities: '<colaborador> fez uma sugestão para o seu plano de desenvolvimento',
    suggestionReceived: '<colaborador> sugeriu que você adicione uma atividade do tipo <actividad> ao seu plano de desenvolvimento',
    makeDevelopmentPlan: 'Você ainda não tem nenhuma atividade ligada à avaliação <evaluacion>, nós convidamos você a trabalhar em seu plano de desenvolvimento',
    haveBeenAssignedTrainingPath: 'O caminho de capacitação foi atribuído: <path>',
    trainingPathHasBeenModified: 'O caminho de capacitação <path> pode ser modificado',
    commitmentDateCloseExpirationActiviy: 'A data de compromisso da atividade <actividad>, estará disponível em breve',
    endDateCloseExpirationActiviy: 'A data de término da atividade <actividad>, estará disponível em breve',
    generalDevelopmentPlanProgressReminder: 'Lembre-se de trabalhar em seu plano de desenvolvimento e registrar o progresso',
    activityDevelopmentPlanProgressReminder: 'Lembre-se de trabalhar em sua <actividad> e registrar o progresso',

    // Academy
    adminEnrolledToCourse: 'O administrador da Academia inscreveu você no curso <curso>',
    adminSentToWaitingList: 'O administrador da Academia enviou você para a lista de espera do curso <curso>',
    concludeCourse: 'Parabenizamos você por concluir o curso <curso>',
    scheduleModified: 'O horário do curso <curso> foi modificado',
    scheduleCancelled: 'O horário do curso <curso> foi cancelado',
    requestsToReview: 'Você tem solicitações de curso pendentes para revisar',
    requestsToReviewAdmin: 'Você tem solicitações de curso <curso> pendentes para revisar na lista de candidatos',
    suggestedSchedule: '<colaborador> sugeriu uma programação do curso <curso>',
    requestReplacementCourse: '<colaborador> solicitou que você fosse o substituto dele no curso <curso>',
    cancelledSubscription: '<colaborador> cancelou sua inscrição no curso <curso>',
    courseRequestApproved: 'Seu supervisor autorizou sua solicitação para o curso <curso>',
    courseRequestRejected: 'Seu supervisor rejeitou sua solicitação para o curso <curso>',
    replacementCourseAccepted: '<colaborador> aceitou a sua substituição para o curso <curso>',
    replacementCourseRejected: '<colaborador> rejeitou a sua substituição do curso <curso>',
    coursesToReview: 'Você tem solicitações de curso pendentes para revisar',
    replacementCourseExpired: 'Informamos que sua solicitação para substituir o curso <curso> expirou',
    courseStartDate: 'Seu curso <curso> começa em <fecha>',
    courseStartDateInstructor: 'Seu curso <curso> em que você é instrutor inicia a <fecha>',
    newAcademyCourses: 'Existem novos cursos da Academy!',
    courseExpireDate: 'Seu curso <curso> expira em <fecha>',
    courseExpired: 'Seu curso <curso> expirou',
    realesedSpaceEnrolledCourse: 'Um espaço no curso <curso> foi liberado e você foi inscrito',
    notSpaceWaitingList: 'Seu facilitador autorizou sua solicitação para o curso <curso> mas no momento não há lugar e você está na lista de espera',
    answerQuestionary: 'Informamos que a pesquisa do curso <curso> foi iniciada. Você tem até antes de <fecha> para responder.',
    courseHaveRegisteredWaiting: 'Informamos que você se inscreveu no curso <curso>, para o qual estava em lista de espera. Agora você está formalmente matriculado',

    // Comunicación
    startEvent: 'Você iniciou o evento <tipoEvento>: <evento>',
    endEvent: 'O evento <tipoEvento> terminou: <evento>',
    assignedToInterview: 'Você foi designado para entrevistar <entrevistado> no evento <tipoEvento>: <evento>',
    scheduledConversation: 'Sua conversa do evento <evento> foi agendada para o <fecha> dia às <hora>',
    assignedDelegate: '<colaborador> designou você como representante de <tipoDelegado> no evento <tipoEvento>: <evento>',
    unassignedDelegate: '<colaborador> desalocado você como representante de <tipoDelegado> no evento <tipoEvento>: <evento>',
    assignedToActivity: '<colaborador> designou você como responsável pela atividade com o ID: <actividad>',
    acceptedActivity: '<responsable> aceitou a atividade com o ID: <actividad>',
    rejectedActivity: '<responsable> rejeitou a atividade com o ID: <actividad>',
    advanceActivity: '<responsable> inseriu um adiantamento na atividade <actividad>',
    haveBeenAddedParticipant: '<colaborador> adicionou você como participante da atividade com o ID: <actividad>',
    haveBeenRemovedParticipant: '<colaborador> removeu você como participante da atividade com o ID: <actividad>',
    deletedActivity: '<colaborador> excluiu atividade com o ID: <actividad>',
    concludedActivity: '<responsable> concluiu a atividade com o ID: <actividad>',
    notFinishedActivity: 'Lembramos que você tem atividades pendentes para concluir',
    remindFinishSurvey: 'Lembramos que termine de responder no evento <tipoEvento>: <evento>',
    remindScheduleConversation: 'Lembramos você de agendar sua conversa com <entrevistado> em no evento <tipoEvento>: <evento>',
    // Sueldos y Promociones
    postulateApproved: 'Seu aplicativo <postulado> foi aprovado por <tercerNivel>',
    postulateRejected: 'Seu aplicativo <postulado> foi rejeitado por <tercerNivel>',
    pendingPostulations: 'Você tem aplicativos pendentes para revisar',
    resultsEvent: 'Revise os resultados do evento <evento>',
    salariesEvent: 'Verifique os salários do evento <evento>',
    postulateEmployee: 'Inscreva-se para colaboradores do evento <evento>!',
    timeToVote: 'É hora de votar no evento <evento>!',

    // Reclutamiento
    requestRejectedManager: 'Informamos que o pedido de <colaborador> para a posição <puesto> foi cancelado pelo comitê',
    requestApprovedManager: 'Informamos que a solicitação do <colaborador> para a posição <puesto> foi confirmada pelo comitê',
    requestRejectedSupervisor: 'Sua inscrição para a posição <puesto> foi cancelada pelo comitê',
    requestApprovatedSupervisor: 'Sua inscrição para a posição <puesto> foi confirmada pelo comitê',
    voteDoubt: 'Informamos que um membro do comitê votou em dúvida sobre a solicitação do <colaborador> para a posição <puesto>',
    requestPendingReview: 'Informamos que você tem solicitações pendentes para revisar',
    requestRejected: 'Informamos que sua inscrição para a posição <puesto> foi rejeitada',
    requestCancelledManager: 'Informamos que o supervisor <colaborador> cancelou sua solicitação para a posição <puesto>',
    requestCancelledSupervisor: 'Sua inscrição na posição <puesto> foi cancelada pelo gerente',
    assignedManager: 'Você foi designado como Gerenciador de Solicitações',
    deleteManager: 'Sua atribuição do gerente de aplicativos foi encerrada',
    assignedCommittee: 'Você foi designado como membro do comitê de votação',
    deleteCommittee: 'Sua atribuição como membro do comitê de votação foi encerrada',
    requestConcludedSupervisor: 'Sua inscrição para a posição <puesto> foi concluída pelo gerente',
    requestApprovated: 'Informamos que sua inscrição para a posição <puesto> foi aprovado e enviado ao comitê para análise',
    requestVoteCommitte: 'As informações que uma nova solicitação foi iniciada na votação',

    // Expediente 360
    shedulePending: 'Você tem cronogramas pendentes para aprovar do <colaborador>',
    sheduleApproved: 'Seu supervisor aprovou sua programação',
    sheduleRejected: 'Seu supervisor rejeitou sua programação',
    backupAssigned: '<colaborador> atribuiu você como seu backup de <fechaInicio> a <fechaFin>',
    cancelledBackup: '<colaborador> cancelou o pedido de backup',
    rejectedBackup: '<colaborador> rejeitou seu pedido como um backup',
    contractExpiration: 'Informamos que o contrato <contrato> do <colaborador> irá expirar em <dias> dias',
    jobRequestPending: 'Informamos que você tem solicitações pendentes de mudança de trabalho para revisão',
    jobRequestRejected: 'Informamos que seu supervisor rejeitou sua solicitação de mudança de posição',
    jobRequestApproved: 'Informamos que seu supervisor aprovou sua solicitação de mudança de trabalho',
    endBackup: 'O período de backup terminou',

    // HelpDesk
    myRequestHasBeenAssigned: 'Sua solicitação #<idreporte> foi atribuída a <especialista>',
    myRequestHasBeenReassigned: 'Sua solicitação #<idreporte> foi reatribuída a <especialista>',
    myRequestHasBeenPaused: 'Sua solicitação #<idreporte> foi pausada por <especialista>',
    myRequestHasBeenCanceled: 'Sua solicitação #<idreporte> foi cancelada por <especialista>',
    myRequestHasBeenClosed: 'Sua solicitação #<idreporte> foi fechada por <especialista>',
    addedCommentsMyRequest: '<especialista> adicionou comentários ao seu pedido #<idreporte>',
    haveBeenAssignedRequest: 'Você recebeu um novo pedido #<idreporte>',
    haveBeenReassignedRequest: 'Você reatribuiu a solicitação #<idreporte>',
    addedCommentsRequest: 'Comentários foram adicionados à solicitação #<idreporte>',
    requestEvaluated: '<colaborador> avaliou a atenção do pedido #<idreporte>',
    requestReopened: 'Eles reabriram sua solicitação #<idreporte>',
    configNonWorkingDaysMoment: 'É hora de configurar os dias não úteis da sua empresa'
  }
};